var map = {
	"./Freight-BigLight.woff2": "FjIK",
	"./Freight-BigLightItalic.woff2": "Ongi",
	"./Gotham-Bold.woff2": "IEio",
	"./Gotham-Book.woff2": "II5j",
	"./Gotham-Medium.woff2": "Z+k0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0LcI";